import React, { createContext, useState, useEffect } from "react";
import { flushSync } from "react-dom";
import { Navigate, useNavigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });
  const [userProfile, setUserProfile] = useState();
  const [subscriptionActive, setSubscriptionActive] = useState(true); // Track subscription status
  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) return;
    let user = JSON.parse(localStorage.getItem("userProfile"));
    if (user) {
      setUserProfile(user);
    }
    setIsLoggedIn(true);
    setSession({ token: token });
  }, []);

  useEffect(() => {
    if (!userProfile) return;
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/dashboard" />;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userProfile");
    flushSync(() => {
      setIsLoggedIn(false);
      setUserProfile(undefined);
      setSession({ token: null });
    });
    ShowToast("Logout Successfully", Severty.SUCCESS);
    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        subscriptionActive,
        setSubscriptionActive,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
